import { KoTabs } from 'packages';
import React from 'react';
import Locations from './locations';
import Division from './division';
import Branch from './branch';
import Categories from './categories';
const Category = () => {
  return (
    <div className="profileSection">
      <KoTabs
        options={[
          {
            label: 'Categories', key: 'categories', children: <Categories/>
          },
          {
            label: 'Locations', key: 'locations', children: <Locations/>
          },
          {
            label: 'Branch', key: 'branch', children: <Branch/>
          },
          {
            label: 'Division', key: 'division', children: <Division/>
          }
        ]} />
    </div>
  );
};

export default Category;